import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import { useQuery, useQueryClient} from 'react-query'
import {PageTitle} from '../../../../_metronic/layout/core'
import {TableDefault} from '../../../components/ui'
import {getListTestimoni} from '../../../modules/services/testimoni.service'
import {getBreadCrumbs} from '../breadcrumbs'

const TestimoniPage = () => {
  const queryClient = useQueryClient()
  const headFields = ['ID', 'Member', 'Testimoni']
  const bodyFields = ['id', 'attributes.member.data.attributes.fullname',  'attributes.testimoni']
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const {data, isLoading} = useQuery(['getListTestimoni', search, page], async () =>
    getListTestimoni(search, page)
  )
  const datas: any = data?.data
  const pageCount = data?.meta?.pagination.pageCount

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Testimoni List</p>
          </div>
        </div>
        {!isLoading && (
          <TableDefault
            head={headFields}
            body={bodyFields}
            data={datas}
            href={'self-care-plan/testimoni'}
            showEdit={true}
            allPaginate={pageCount}
            page={page}
            setsPage={setPage}
            nextPage={nextPage}
            prevPage={prevPage}
            texts={'Apakah anda yakin ingin menghapus testimoni ini'}
          />
        )}
      </div>
    </>
  )
}

const TestimoniWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('self-care-plan/testimoni')}>
        Testimoni
      </PageTitle>
      <TestimoniPage />
    </>
  )
}

export default TestimoniWrapper
